import type { PersonalDocument } from "@/types/personalDocument"

export default function PersonalDocumentBody({
  document,
}: {
  document: PersonalDocument
}) {
  const blocks = document.blocks ?? []

  return (
    <>
      {blocks.map((block) => (
        <section key={block.id ?? block.title} className="mb-4">
          {block.title ? (
            <h3 className="mb-2 font-medium text-white">{block.title}</h3>
          ) : null}
          {block.content ? <p className="mb-2">{block.content}</p> : null}
          {block.subContent?.map((sub) => (
            <div key={sub.id ?? sub.content} className="mb-2">
              {sub.content ? <p>{sub.content}</p> : null}
              {sub.list?.map((li) => (
                <p key={li} className="ml-3">
                  • {li}
                </p>
              ))}
            </div>
          ))}
        </section>
      ))}
    </>
  )
}
